// const BASEURL = 'https://corrugated.hp-blueprint.com/';
// const BASEAPIURL = 'https://corrugated.hp-blueprint.com/api/';
const BASEURL = 'https://corrugated-dev.hp-blueprint.com/';
const BASEAPIURL = 'https://corrugated-dev.hp-blueprint.com/api/';
const EXT = '.php';
const CMS = 'https://admin-dev-corrugated.hp-blueprint.com/';

export { BASEURL, BASEAPIURL, EXT, CMS };
